import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import { IProfile, IProfileTab, IProfileTabsFilters } from '@/openMarket/domain/vo/IProfile';
import { IFetchCollectionPayload, IFetchCollectionResponse } from '@framework/state/useFetchCollection';

@injectable()
class ProfileRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcher) {}

  getProfiles = async (payload: IFetchCollectionPayload): Promise<IFetchCollectionResponse<IProfile>> => {
    const request = new Request('finsight_web.open_market.get_profiles', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getProfile = async ({ viewId, alias }: { viewId?: number, alias?: string }): Promise<IProfile> => {
    const request = new Request('finsight_web.open_market.get_profile', { viewId, alias });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getProfileTabs = async ({
    viewId,
    filters,
  }: {
    viewId: number,
    filters?: IProfileTabsFilters,
  }): Promise<IProfileTab[]> => {
    const request = new Request('finsight_web.open_market.get_profile_display_tabs', { viewId, filters });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default ProfileRepository;
